import { analyticsAPI } from "services/apis.service";

export class GroupAnalyticsService {
  #axios;
  constructor(axiosInstance) {
    this.#axios = axiosInstance;
  }

  async getAnalyticsOverviewData(payload) {
    try {
      const { data } = await this.#axios.post(
        analyticsAPI.getGroupOverview,
        payload
      );
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
